import PageBasicTemplate from '../components/PageBasicTemplate';
import WorksGallery from '../components/redesign/WorksGallery';
export default function Works() {
  return <PageBasicTemplate title="相談事例・実績" sub_title="課題を見つめ、技術でかたちにする。FRiCTONへのご相談から生まれた仕組みと、開発の取り組みをご紹介します。">
    <div className="intro-layout"><h2 className="content-heading">一つひとつの課題に、<br />一つひとつの実装を。</h2><p>AI・Web・モバイルから、ネットワーク基盤まで。使う人の体験と、運用する人の仕事に向き合い、事業に必要な仕組みをつくります。</p></div>
    <WorksGallery />
  </PageBasicTemplate>;
}
